import React, { useEffect } from "react";
import "./manualorganizacion.css";

const ManualOrganizacion = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="container manualorganizacion-container">
      <div className="row">
        <div className="col_12">
          <div className="manualorganizacion_title">
            <h1>Manual de Organización</h1>
          </div>
        </div>
      </div>

      <hr className="hr-gob" />

      <div>
        <iframe
          // type="application/pdf"
          // src="https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SEDAGROH/DocsPagweb/MANUAL_ORGANIZACION_2022.pdf"
           src="https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2025/DocsPagweb/ManualOrganizacionalSADERH2024.pdf"
          height="1500"
          width="1110"
        ></iframe>
      </div>
    </div>
  );
};

export default ManualOrganizacion;
